import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconLockRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.013 7.999a5 5 0 0 1 10 0v1h.5c1.345 0 2.5 1.06 2.5 2.445v7.11c0 1.386-1.155 2.445-2.5 2.445h-11c-1.345 0-2.5-1.06-2.5-2.445v-7.11c0-1.386 1.155-2.445 2.5-2.445h.5v-1Zm8 0v1h-6v-1a3 3 0 1 1 6 0Zm-1.718 5.88c0 .426-.213.803-.54 1.033a.499.499 0 0 1 .041.157l.119 1.32a.5.5 0 0 1-.498.545h-.802a.5.5 0 0 1-.497-.55l.135-1.321a.498.498 0 0 1 .035-.139 1.261 1.261 0 0 1-.558-1.045c0-.7.574-1.268 1.283-1.268.708 0 1.282.568 1.282 1.268Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconLockRoundFill);
export default Memo;
